import React, { Component, lazy, Suspense } from "react"
import { Link, withRouter } from "react-router-dom"
import { Grid, Typography, Container, Button, Box } from "@material-ui/core"
import withStyles from "@material-ui/core/styles/withStyles"
import PlaylistAddIcon from "@material-ui/icons/PlaylistAdd"
import { connect } from "react-redux"
import Skeleton from "react-loading-skeleton"
import HighlightBadge from "../PackagesList/packageCard/highlightBadge"
import { getCompareListAction } from "../../store/actions/getComparelist.action"
import { getPackageListAction } from "../../store/actions/packageList.action"
import { getPackageDetailAction } from "../../store/actions/getPackageDetail.action"
import { getResponseNullAction } from "../../store/actions/getPackageDetail.action"

import { Helmet } from "react-helmet"
import { TrackingOrigin, TrackingPageName } from "../../../tracking/trackingConstants"
import { Tracker } from "../../../tracking/tracker"
import { PackageDetailPageViewEvent } from "../../../tracking/events/packageDetailPageViewEvent"
import SaleInfo from "../../models/listing/saleInfo"
import DiscountBadge from "../PackagesList/packageCard/discountBadge"
import icon_whatsapp from "../../../app/assets/images/icon_whatsapp.svg"
import { WhatsappUtil } from "../../../utils/whatsappUtil"
import { PackageOpenWhatsappEvent, WhatsappOpenEventOrigin } from "../../../tracking/events/packageOpenWhatsappEvent"
import { NavigationContext } from "../../navigation/navigationContext"
const Navbar = lazy(() => import("./header"))
const DailogBox = lazy(() => import("./images"))
const CompareDailog = lazy(() => import("./compareDailog/CompareDailog"))
const Footer = lazy(() => import("../footer/footer"))
const Facility = lazy(() => import("./packageFacilities"))
const Itenary = lazy(() => import("./Itenary/DayChange"))
const RelatedPackage = lazy(() => import("./RelationPackage/related"))
const AccomodationSightseeing = lazy(() => import("./Accommodation/newAccomodation"))
const Inclusion = lazy(() => import("./inclusion&exclusion/inclusion"))
const Registration = lazy(() => import("../PackagesList/RequestForPackage/PackageCall"))

const style = (theme) => ({
	root: {
		flexGrow: 1,
	},
	tags: {
		padding: "0px 16px 16px 0px",
		"& > *": {
			marginRight: theme.spacing(3),
			marginTop: theme.spacing(1),
			marginBottom: theme.spacing(1),
		},
	},
	images: {
		display: "flex",
		[theme.breakpoints.down("sm")]: {
			overflowX: "scroll",
			marginTop: theme.spacing(10),
		},
	},

	ButtonSeeCompare: {
		color: "#ff8362",
		textTransform: "none",
		marginRight: theme.spacing(1),
		[theme.breakpoints.down("sm")]: {
			display: "none",
		},
	},
	perperson: {
		color: "#616e78",
		textAlign: "end",
		fontSize: 14,
		[theme.breakpoints.down("sm")]: {
			fontSize: 12,
			textAlign: "start",
		},
	},

	price: {
		color: "#16222b",
		fontSize: 28,

		textAlign: "end",
		[theme.breakpoints.down("sm")]: {
			marginTop: theme.spacing(1),
			fontSize: 20,
			width: "max-content",
			// textAlign: "start"
		},
	},
	rowdata: {
		marginTop: theme.spacing(3),

		[theme.breakpoints.down("sm")]: {
			marginTop: theme.spacing(2),
		},
	},
	img: {
		objectFit: "cover",
		[theme.breakpoints.down("sm")]: {
			width: 370,
			paddingRight: theme.spacing(1),
		},
	},

	gridImage1: {
		height: "80vh",
		paddingRight: theme.spacing(1),
		[theme.breakpoints.down("sm")]: {
			height: "40vh",
		},
	},
	tourName: {
		textTransform: "capitalize",
		color: "#16222b",
		fontSize: 28,
		[theme.breakpoints.down("sm")]: {
			fontSize: 20,
		},
	},
	duration: {
		color: "#616E78",
		fontSize: 20,
		[theme.breakpoints.down("sm")]: {
			fontSize: 16,
		},
	},
	gridImage2: {
		height: "40vh",
	},
	gridImage3: {
		height: "40vh",
		paddingRight: theme.spacing(1),
		paddingTop: theme.spacing(1),
		[theme.breakpoints.down("sm")]: {
			paddingRight: theme.spacing(0),
		},
	},
	gridImage4: {
		height: "40vh",

		paddingTop: theme.spacing(1),
	},
	commonclass: {
		[theme.breakpoints.down("sm")]: {
			display: "flex",
		},
	},
	firstRow: {
		display: "flex",
		[theme.breakpoints.down("sm")]: {
			display: "block",
		},
	},
	RequestCall: {
		width: "100%",
		textAlign: "center",
		fontSize: 16,
		[theme.breakpoints.down("sm")]: {
			fontSize: 14,
		},
	},

	completeImageGrid: {
		display: "flex",
		overflowX: "hidden",
		cursor: "pointer",
		[theme.breakpoints.down("sm")]: {
			overflowX: "scroll",
		},
	},

	secondGrid: {
		flexWrap: "wrap",
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-end",
		[theme.breakpoints.down("sm")]: {
			justifyContent: "flex-start",
		},
	},
	secondcol: {
		display: "block",
		[theme.breakpoints.down("xs")]: {
			display: "flex",
		},
	},

	rightCol: {
		justifyContent: "flex-end",
		[theme.breakpoints.down("xs")]: {
			justifyContent: "space-between",
			marginTop: 8,
		},
	},
	departureText: {
		color: "#16222B",
		padding: "16px 16px 16px 0px ",
		fontSize: 24,
		[theme.breakpoints.down("sm")]: {
			fontSize: 16,
		},
	},
	agentName: {
		color: "#224E6D",
		fontSize: 16,
		fontWeight: "bold",
		paddingTop: 8,
		[theme.breakpoints.down("sm")]: {
			fontSize: 16,
		},
	},
	retailPrice: {
		color: "#000",
		fontSize: 24,
		marginRight: "8px",
		textDecoration: "line-through",
		[theme.breakpoints.down("md")]: {
			fontSize: 20,
		},
	},
	salePrice: {
		color: "#ff6840",
		fontSize: 28,
		fontWeight: 600,
		[theme.breakpoints.down("md")]: {
			fontSize: 24,
		},
	},
	pricingGrid: {
		justifyContent: "flex-end",
		display: "flex-end",
		[theme.breakpoints.down("xs")]: {
			display: "block",
		},
	},
	pricingDiscount: {
		[theme.breakpoints.down("xs")]: {
			display: "none",
		},
	},
	titleDiscount: {
		[theme.breakpoints.up("sm")]: {
			display: "none",
		},
	},
	whatsappButton: {
		backgroundColor: "transparent",
		hover: "none",
		paddingLeft: 0,
		margin: 0,
		minWidth: "auto", // Add this line to make the button size as per the image
		[theme.breakpoints.down("sm")]: {
			paddingLeft: theme.spacing(1),
		},
		[theme.breakpoints.up("sm")]: {
			paddingRight: theme.spacing(1),
		},
	},
	whatsappImage: {
		width: "32px",
		height: "32px",
	},
})
class PackageDetails extends Component {
	static contextType = NavigationContext

	constructor(props) {
		super(props)
		this.state = {
			photoIndex: 0,
			BoxOpen: false,
			images: [],
			open: false,
			compareOpen: false,
			requestId: "",
			isClick: false,
			url: "",
			pageNumber: 4,
			count: 4,
			destId: JSON.parse(localStorage.getItem("destId")),
			themeId: JSON.parse(localStorage.getItem("themeId")) || [],
			themeName: JSON.parse(localStorage.getItem("themeName")) || [],
			compareData: JSON.parse(localStorage.getItem("compare")) || [],
			idArray: JSON.parse(localStorage.getItem("packageId")) || [],
			popularPackage: JSON.parse(localStorage.getItem("popularPackage")),
			title_tags: "",
			description_tags: "",
		}

		this.closeBox = this.closeBox.bind(this)
	}
	componentDidMount = () => {
		const getLastItem = (thePath) => thePath.substring(thePath.lastIndexOf("/") + 1)
		let lastpath = getLastItem(window.location.pathname)

		// Tracking Page View
		this.context.setBrowsingPage(TrackingPageName.PackageDetail)

		this.setState({
			url: window.location.href,
		})
		window.scrollTo(0, 0)
		// let params = new URLSearchParams(window.location.search.substring(1));
		// let value = params.get("packageId");
		this.props.getPackageDetailAction({
			params: { package_id: lastpath },
		})
	}
	componentWillUnmount = () => {
		this.props.getResponseNullAction()
	}

	componentWillReceiveProps = (nextProps) => {
		let tags = nextProps && nextProps._packageDetails && nextProps._packageDetails.data && nextProps._packageDetails.data.data && nextProps._packageDetails.data.data.meta_tag
		if (tags) {
			this.setState({
				title_tags: tags.title,
				description_tags: tags.description,
			})
		}
	}
	handleStorageDailog = (value) => {
		this.setState(
			{
				compareData: this.state.compareData.concat(value),
				idArray: this.state.idArray.concat(value.id),
			},
			() => {
				localStorage.setItem("compare", JSON.stringify(this.state.compareData))
				localStorage.setItem("packageId", JSON.stringify(this.state.idArray))
			}
		)
		this.props.getPackageListAction()
	}
	handlerelatedPackage = (id) => {
		window.location.href = `/packagedetails/${id}`
	}

	delete = (id) => {
		const deleteFrmLocal = JSON.parse(localStorage.getItem("compare"))
		const afterdelete = deleteFrmLocal.filter((el) => el.id !== id)
		localStorage.setItem("compare", JSON.stringify(afterdelete))
		this.setState({
			compareData: afterdelete,
		})
		const deleteId = JSON.parse(localStorage.getItem("packageId"))
		const iddeleted = deleteId.filter((el) => el !== id)

		localStorage.setItem("packageId", JSON.stringify(iddeleted))
		this.setState({
			idArray: iddeleted,
		})
	}
	handleCompareOpen = () => {
		this.setState({
			compareOpen: true,
		})
	}
	handleCompareClose = () => {
		if (this.state.compareDate === null) {
			this.setState({
				compareOpen: false,
			})
		}
		this.setState({
			compareOpen: false,
		})
	}
	handleCompare = (id) => {
		this.setState({
			open: true,
			requestId: id,
		})
	}
	handleClose = () => {
		this.setState({ open: false })
	}

	openBox = (obj) => {
		this.setState({
			BoxOpen: true,
			images: obj,
		})
	}
	closeBox = () => {
		this.setState({
			BoxOpen: false,
		})
	}

	handleTags = (item) => {
		if (item.theme_name) {
			this.setState({
				themeId: this.state.themeId.includes(item.id) ? "" : this.state.themeId.push(item.id),
				themeName: this.state.themeName.includes(item.theme_name) ? "" : this.state.themeName.push(item.theme_name),
			})
		}

		if (item.region_name) {
			this.setState({
				destId: item.id,
			})
		}
		this.props.getPackageListAction({
			params: { theme_id: [item.id] },
		})
		this.props.getPackageListAction({ params: { destination_id: item.id } })
		localStorage.setItem("destId", JSON.stringify(this.state.destId))
		localStorage.setItem("themeId", JSON.stringify(this.state.themeId))
		localStorage.setItem("themeName", JSON.stringify(this.state.themeName))
	}

	onWhatsAppClick = () => {
		const whatsappUtil = new WhatsappUtil()
		const packageData = this.props._packageDetails.data.data
		const name = packageData.tour_name

		const saleInfo = packageData && packageData.sale_info && new SaleInfo(packageData.sale_info)
		const price = saleInfo ? saleInfo.listPrice.displayValue : "Price not available"
		const pageUrl = window.location.toString()
		Tracker.getInstance().trackEvent(new PackageOpenWhatsappEvent(WhatsappOpenEventOrigin.DETAIL_PAGE, packageData.slug))

		whatsappUtil.openWhatsappForPackage(name, price, pageUrl)
	}

	render() {
		const { _packageDetails, classes } = this.props
		const { title_tags, description_tags } = this.state

		const data2 = _packageDetails.data
		let data = data2 && data2.data
		let id = data && data.id
		const PdfFile = data && data.itinerary_pdf
		const image1 = data && data.package_images && data.package_images[0]
		const image2 = data && data.package_images && data.package_images[1]
		const image3 = data && data.package_images && data.package_images[2]
		const image4 = data && data.package_images && data.package_images[3]
		const images =
			data &&
			data.package_images &&
			data.package_images.map((item) => {
				return item
			})
		const saleInfo = data && new SaleInfo(data.sale_info)
		const shouldShowRetailPrice = (saleInfo && saleInfo.retailPrice && saleInfo.shouldShowRetailPrice) ?? false
		const retailPrice = saleInfo && saleInfo.retailPrice
		const salePrice = saleInfo && saleInfo.listPrice
		const discountPercentage = saleInfo && saleInfo.discountPercentage

		return (
			<React.Fragment>
				<Helmet>
					<title>{title_tags}</title>
					<meta data-react-helmet={true} name="description" content={description_tags} />
					<meta name="keywords" content="packageDetailPage" />
				</Helmet>

				<Suspense fallback={<h6 style={{ color: "transparent" }}>loading...</h6>}>
					<Navbar style={{ background: "#16222b" }} parentPageName={TrackingPageName.PackageDetail} />
				</Suspense>
				{!_packageDetails.data ? (
					<Skeleton height="100vh" width="100%" style={{ color: "primary" }}></Skeleton>
				) : (
					<Grid container justifyContent="space-around" direction="column">
						<Grid md={12} xs={12} sm={12} item className={classes.completeImageGrid}>
							<Grid md={6} sm={6} item className={classes.gridImage1}>
								<img src={image1} alt="image1" width="100%" height="100%" style={{ objectFit: "cover" }} onClick={() => this.openBox(image1)} />
							</Grid>
							<Grid md={6} sm={6} xs={2} item className={classes.commonclass}>
								<Grid md={12} sm={12} className={classes.gridImage2}>
									<img src={image2} alt="image2" width="100%" height="100%" className={classes.img} onClick={() => this.openBox(image2)} />
								</Grid>

								<Grid container direction="column">
									<Grid md={12} justifyContent="space-between" item style={{ display: "flex" }}>
										<Grid md={6} sm={6} item className={classes.gridImage3}>
											<img src={image3} className={classes.img} alt="image3" width="100%" height="100%" onClick={() => this.openBox(image3)} />
										</Grid>
										<Grid md={6} sm={6} item className={classes.gridImage4}>
											<img src={image4} alt="image4" className={classes.img} width="100%" height="100%" onClick={() => this.openBox(image4)} />
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
						<Suspense fallback={<h6 style={{ color: "transparent" }}>loading...</h6>}>
							<DailogBox open={this.state.BoxOpen} images={images} currimagesentImage={this.state.images} close={this.closeBox} />
						</Suspense>
					</Grid>
				)}
				{data ? (
					<Grid>
						<Container className={classes.root}>
							<Grid md={12} xs={12} sm={12} container justifyContent="space-between" direction="row" style={{ marginTop: 24 }}>
								<Grid xs={12} sm={7} item container>
									<Grid container item xs={10} style={{ display: "block" }}>
										<Typography className={classes.tourName}>{data.tour_name.toLowerCase()}</Typography>
										<Grid container item alignItems="center" spacing={1}>
											{data.highlights && (
												<Grid item>
													<HighlightBadge text={data.highlights.badge} backgroundColor={data.highlights.color} />
												</Grid>
											)}
											<Grid item>
												<Typography className={classes.duration}>{data.duration}</Typography>
											</Grid>
										</Grid>

										<Typography className={classes.agentName}>Tour Operator: {data.created_by.name}</Typography>
									</Grid>
									{discountPercentage && discountPercentage > 0 ? (
										<Grid container item xs={2}>
											<div className={classes.titleDiscount} style={{ paddingLeft: "10px" }}>
												<DiscountBadge discount={discountPercentage} color={saleInfo.discountColor} />
											</div>
										</Grid>
									) : (
										""
									)}
								</Grid>
								<Grid xs={12} sm={5} item container className={classes.rightCol}>
									<Grid xs={6} sm={12} item className={classes.secondcol}>
										<Grid container item className={classes.pricingGrid}>
											{shouldShowRetailPrice && <Typography className={classes.retailPrice}>{retailPrice.displayValue}</Typography>}
											<Grid style={{ display: "block" }}>
												<Typography className={classes.salePrice}>{salePrice.displayValue}</Typography>
												<Typography variant="subtitle2" className={classes.perperson}>
													Per Person
												</Typography>
											</Grid>
											{discountPercentage && discountPercentage > 0 ? (
												<div className={classes.pricingDiscount} style={{ paddingLeft: "10px" }}>
													<DiscountBadge discount={discountPercentage} color={saleInfo.discountColor} />
												</div>
											) : (
												""
											)}
										</Grid>
									</Grid>
									<Grid
										style={{
											display: "flex",
											alignItems: "center",
										}}>
										{this.state.compareData.length === 3 || this.state.idArray.includes(data.id) ? (
											<Button variant="text" className={classes.ButtonSeeCompare} onClick={() => this.handleCompareOpen()}>
												<Typography variant="subtitle1">Show Compare List</Typography>
											</Button>
										) : (
											<Button
												variant="text"
												className={classes.ButtonSeeCompare}
												style={{
													color: this.state.isClick ? "green" : "#ff8362",
													textTransform: "none",
												}}
												onClick={() =>
													this.handleStorageDailog({
														id: data.id,
														name: data.tour_name,
														price: data.price,
														duration: data.duration,
													})
												}>
												<PlaylistAddIcon style={{ color: "#224e6d", marginRight: 5 }} />
												<Typography variant="subtitle1" color="secondary">
													ADD TO COMPARE
												</Typography>
											</Button>
										)}
										{window.innerWidth > 600 ? (
											<Grid direction="row">
												<Button className={classes.whatsappButton} onClick={this.onWhatsAppClick}>
													<img src={icon_whatsapp} alt="WhatsApp" className={classes.whatsappImage} />
												</Button>
											</Grid>
										) : (
											""
										)}
										<Button
											variant="contained"
											color="primary"
											onClick={() => this.handleCompare(data.id)}
											style={{
												height: "36px",
												width: "153px",
												textTransform: "none",
											}}>
											<Typography className={classes.RequestCall} variant="subtitle1" style={{ width: "100%", textAlign: "center" }}>
												Request a Call
											</Typography>
										</Button>
										{window.innerWidth <= 600 ? (
											<Grid direction="row">
												<Button className={classes.whatsappButton} onClick={this.onWhatsAppClick}>
													<img src={icon_whatsapp} alt="WhatsApp" className={classes.whatsappImage} />
												</Button>
											</Grid>
										) : (
											""
										)}
									</Grid>
								</Grid>
							</Grid>
							<Suspense fallback={<h6 style={{ color: "transparent" }}>loading...</h6>}>
								<Facility highlights={data.package_highlight} tags={data.destination_theme} departureCities={data.departure_cities} FilterByTags={(val) => this.handleTags(val)} />
							</Suspense>
							<Grid style={{ marginTop: "4%" }}>
								{data ? (
									<Suspense fallback={<h6 style={{ color: "transparent" }}>loading...</h6>}>
										<Itenary itenirary={data.itenirary} Pdf={PdfFile} packageId={id} />
									</Suspense>
								) : (
									<Skeleton width={20} height={100} />
								)}
							</Grid>
							<Grid style={{ marginTop: "4%" }}>
								<Suspense fallback={<h6 style={{ color: "transparent" }}>loading...</h6>}>
									<AccomodationSightseeing accomodation={data.package_accomodation} sightseeing={data.sightseeing} />
								</Suspense>
							</Grid>

							<Grid style={{ marginTop: "6%" }}>
								<Suspense fallback={<h6 style={{ color: "transparent" }}>loading...</h6>}>
									<Inclusion inclusion={data && data.package_inclusion} exclusion={data && data.package_exclusion} />
								</Suspense>
							</Grid>
							{data && data.agent_terms === 1 ? (
								<Grid md={12} sm={12} xs={12} item container justifyContent="center" style={{ marginTop: "6%" }}>
									<Link to={`/termsCondition?packageId=${data.id}`} target="_blank" style={{ textDecoration: "none" }}>
										<Typography color="primary" variant="subtitle1">
											TERMS {"&"} CONDITIONS
										</Typography>
									</Link>
								</Grid>
							) : (
								""
							)}
							<Grid
								style={{
									marginTop: data && data.agent_terms === 1 ? "2%" : "7%",
								}}>
								<Suspense fallback={<h6 style={{ color: "transparent" }}>loading...</h6>}>
									<RelatedPackage data={data.related_packages} id={(id) => this.handlerelatedPackage(id)} />
								</Suspense>
							</Grid>
						</Container>
						<Suspense fallback={<h6 style={{ color: "transparent" }}>loading...</h6>}>
							<Footer />
						</Suspense>
					</Grid>
				) : (
					""
				)}
				<Suspense fallback={<h6 style={{ color: "transparent" }}>loading...</h6>}>
					<Registration
						open={this.state.open}
						id={this.state.requestId}
						onClose={this.handleClose}
						pageNumber={this.state.pageNumber}
						package_url={this.state.url}
						origin={TrackingOrigin.LeadForm.PackageDetail}
					/>
				</Suspense>
				<Suspense fallback={<h6 style={{ color: "transparent" }}>loading...</h6>}>
					<CompareDailog open={this.state.compareOpen} click={this.state.compareData} deleteId={this.delete.bind(this)} onClose={this.handleCompareClose} />
				</Suspense>
				{/* <FilterModel
          open={this.state.filterModel}
          close={this.modelClose}
          data={data}
        /> */}
			</React.Fragment>
		)
	}
}
const mapStateToProps = ({ getPackageDetailReducer, getCompareListReducer, getPackageListReducer }) => {
	return {
		_comparelist: getCompareListReducer,
		_packageDetails: getPackageDetailReducer,
		_packageList: getPackageListReducer,
	}
}
export default withRouter(
	connect(mapStateToProps, {
		getCompareListAction,
		getPackageListAction,
		getPackageDetailAction,
		getResponseNullAction,
	})(withStyles(style)(PackageDetails))
)
